<template>
  <div>
    <template>


      <div>
        <div class="row rowgap">
          <div class="col-md-12">
            <p class="title-content">
              Student Information (Section-1 & 2) and Training Plan (Section-5) of the Form I-983 will be shared with the student for completion.
            </p>
          </div>
        </div>
      </div>
      <div class="row rowgap">
        <div class="col-md-4">
          <div class="form-group">
            <label>Student Name</label><span class="validation-star">*</span>
            <ob-input InitiateI983Popup v-model.trim="StudentDetails.StudentName" placeholder="Enter Student Name" :class="{ 'ob-vuelidate_input-error': $v.StudentDetails.StudentName.$error }"></ob-input>
            <span class="ob-vuelidate_error-msg" v-if="$v.StudentDetails.StudentName.$dirty && !$v.StudentDetails.StudentName.required">Enter name</span>
            <!-- <span class="ob-vuelidate_error-msg" v-if="$v.StudentDetails.StudentName.$dirty && !$v.StudentDetails.StudentName.alphawithspace">Enter alphabets only</span> -->
            <span class="ob-vuelidate_error-msg" v-if="$v.StudentDetails.StudentName.$dirty && !$v.StudentDetails.StudentName.maxLength && $v.StudentDetails.StudentName.alpha">Enter 150 characters only</span>
            <span class="ob-vuelidate_error-msg" v-if="$v.StudentDetails.StudentName.$dirty &&  $v.StudentDetails.StudentName.alpha && !$v.StudentDetails.StudentName.letterCount">Each word can have a maximum of 100 characters only.</span>
          </div>
        </div>
        <div class="col-md-4">
          <div class="form-group">
            <label>Student Email Address</label><span class="validation-star">*</span>
            <ob-input v-model.trim="StudentDetails.Email" placeholder="Enter Student Email Address" :class="{ 'ob-vuelidate_input-error': $v.StudentDetails.Email.$error }"></ob-input>
            <template v-if="$v.StudentDetails.Email.$dirty">
              <span class="ob-vuelidate_error-msg" v-if="!$v.StudentDetails.Email.required">Enter Email ID</span>
              <span class="ob-vuelidate_error-msg" v-else-if="!$v.StudentDetails.Email.email">Enter valid email</span>
            </template>
          </div>
        </div>
        <div class="col-md-4 ">
          <div class="form-group">
            <label>Employer Name</label><span class="validation-star">*</span>
            <ob-input InitiateI983Popup v-model.trim="StudentDetails.EmployerName" placeholder="Enter Employer Name" :class="{ 'ob-vuelidate_input-error': $v.StudentDetails.EmployerName.$error }"></ob-input>
            <span class="ob-vuelidate_error-msg" v-if="$v.StudentDetails.EmployerName.$dirty && !$v.StudentDetails.EmployerName.required">Enter Employer Name</span>
            <!-- <span class="ob-vuelidate_error-msg" v-if="$v.StudentDetails.EmployerName.$dirty && !$v.StudentDetails.EmployerName.alphawithspace">Enter alphabets only</span> -->
            <span class="ob-vuelidate_error-msg" v-if="$v.StudentDetails.EmployerName.$dirty && !$v.StudentDetails.EmployerName.maxLength && $v.StudentDetails.EmployerName.alpha">Enter 150 characters only</span>
            <span class="ob-vuelidate_error-msg" v-if="$v.StudentDetails.EmployerName.$dirty &&  $v.StudentDetails.EmployerName.alpha && !$v.StudentDetails.EmployerName.letterCount">Each word can have a maximum of 100 characters only.</span>

          </div>
        </div>
      </div>

      <div class="row rowgap">
        <label class="col-md-12">Fill the details of the Signatory Authority/Supervisor</label>
        <div class="col-md-4">
          <div class="form-group">
            <label>Site Name</label><span class="validation-star">*</span>
            <ob-input v-model.trim="StudentDetails.SignatoryAuthority.SiteName" placeholder="Enter Site Name" :class="{ 'ob-vuelidate_input-error': $v.StudentDetails.SignatoryAuthority.SiteName.$error }"></ob-input>
            <span class="ob-vuelidate_error-msg" v-if="$v.StudentDetails.SignatoryAuthority.SiteName.$dirty && !$v.StudentDetails.SignatoryAuthority.SiteName.required">Enter Site Name</span>
            <span class="ob-vuelidate_error-msg" v-if="$v.StudentDetails.SignatoryAuthority.SiteName.$dirty && !$v.StudentDetails.SignatoryAuthority.SiteName.alphawithspace">Enter alphabets only</span>
            <span class="ob-vuelidate_error-msg" v-if="$v.StudentDetails.SignatoryAuthority.SiteName.$dirty && !$v.StudentDetails.SignatoryAuthority.SiteName.maxLength && $v.StudentDetails.SignatoryAuthority.SiteName.alpha">Enter 150 characters only</span>
            <span class="ob-vuelidate_error-msg" v-if="$v.StudentDetails.SignatoryAuthority.SiteName.$dirty &&  $v.StudentDetails.SignatoryAuthority.SiteName.alpha && !$v.StudentDetails.SignatoryAuthority.SiteName.letterCount">Each word can have a maximum of 100 characters only.</span>
          </div>
        </div>
        <div class="col-md-8">
          <div class="form-group">
            <label>Site Address (Street, City, State, ZIP)</label><span class="validation-star">*</span>
            <ob-input v-model.trim="StudentDetails.SignatoryAuthority.SiteAddress" placeholder="Enter Site Address (Street, City, State, ZIP)" :class="{ 'ob-vuelidate_input-error': $v.StudentDetails.SignatoryAuthority.SiteAddress.$error }"></ob-input>
            <span class="ob-vuelidate_error-msg" v-if="$v.StudentDetails.SignatoryAuthority.SiteAddress.$dirty && !$v.StudentDetails.SignatoryAuthority.SiteAddress.required">Enter Site Address</span>
            <span class="ob-vuelidate_error-msg" v-if="$v.StudentDetails.SignatoryAuthority.SiteAddress.$dirty && !$v.StudentDetails.SignatoryAuthority.SiteAddress.maxLength && $v.StudentDetails.SignatoryAuthority.SiteAddress.alpha">Enter 150 characters only</span>
            <span class="ob-vuelidate_error-msg" v-if="$v.StudentDetails.SignatoryAuthority.SiteAddress.$dirty &&  $v.StudentDetails.SignatoryAuthority.SiteAddress.alpha && !$v.StudentDetails.SignatoryAuthority.SiteAddress.letterCount">Each word can have a maximum of 100 characters only.</span>
          </div>
        </div>
      </div>

      <div class="row rowgap">
        <div class="col-md-4">
          <div class="form-group">
            <label>Name of Official</label><span class="validation-star">*</span>
            <ob-input InitiateI983Popup v-model.trim="StudentDetails.SignatoryAuthority.NameOfOficial" placeholder="Enter Name of Official" :class="{ 'ob-vuelidate_input-error': $v.StudentDetails.SignatoryAuthority.NameOfOficial.$error }"></ob-input>
            <span class="ob-vuelidate_error-msg" v-if="$v.StudentDetails.SignatoryAuthority.NameOfOficial.$dirty && !$v.StudentDetails.SignatoryAuthority.NameOfOficial.required">Enter Name of Official</span>
            <!-- <span class="ob-vuelidate_error-msg" v-if="$v.StudentDetails.SignatoryAuthority.NameOfOficial.$dirty && !$v.StudentDetails.SignatoryAuthority.NameOfOficial.alphawithspace">Enter alphabets only</span> -->
            <span class="ob-vuelidate_error-msg" v-if="$v.StudentDetails.SignatoryAuthority.NameOfOficial.$dirty && !$v.StudentDetails.SignatoryAuthority.NameOfOficial.maxLength && $v.StudentDetails.SignatoryAuthority.NameOfOficial.alpha"> Enter 150 characters only</span>
            <span class="ob-vuelidate_error-msg" v-if="$v.StudentDetails.SignatoryAuthority.NameOfOficial.$dirty &&  $v.StudentDetails.SignatoryAuthority.NameOfOficial.alpha && !$v.StudentDetails.SignatoryAuthority.NameOfOficial.letterCount">Each word can have a maximum of 100 characters only.</span>
          </div>
        </div>
        <div class="col-md-4">
          <div class="form-group">
            <label>Official's Title</label><span class="validation-star">*</span>
            <ob-input v-model.trim="StudentDetails.SignatoryAuthority.Title" placeholder="Enter Official's Title" :class="{ 'ob-vuelidate_input-error': $v.StudentDetails.SignatoryAuthority.Title.$error }"></ob-input>
            <span class="ob-vuelidate_error-msg" v-if="$v.StudentDetails.SignatoryAuthority.Title.$dirty && !$v.StudentDetails.SignatoryAuthority.Title.required"> Enter Official's Title</span>
            <span class="ob-vuelidate_error-msg" v-if="$v.StudentDetails.SignatoryAuthority.Title.$dirty && !$v.StudentDetails.SignatoryAuthority.Title.maxLength && $v.StudentDetails.SignatoryAuthority.Title.alpha"> Enter 150 characters only</span>
            <span class="ob-vuelidate_error-msg" v-if="$v.StudentDetails.SignatoryAuthority.Title.$dirty &&  $v.StudentDetails.SignatoryAuthority.Title.alpha && !$v.StudentDetails.SignatoryAuthority.Title.letterCount">Each word can have a maximum of 100 characters only.</span>
          </div>
        </div>
        <div class="col-md-4 ">
          <div class="form-group">
            <label>Official's Email</label><span class="validation-star">*</span>
            <ob-input v-model.trim="StudentDetails.SignatoryAuthority.Email" placeholder="Enter Official's Email" :class="{ 'ob-vuelidate_input-error': $v.StudentDetails.SignatoryAuthority.Email.$error }"></ob-input>
            <template v-if="$v.StudentDetails.SignatoryAuthority.Email.$dirty">
              <span class="ob-vuelidate_error-msg" v-if="!$v.StudentDetails.SignatoryAuthority.Email.required"> Enter Official's Email</span>
              <span class="ob-vuelidate_error-msg" v-else-if="!$v.StudentDetails.SignatoryAuthority.Email.email"> Enter valid email</span>
            </template>
          </div>
        </div>
      </div>

      <div class="row rowgap">
        <div class="col-md-4">
          <div class="form-group">
            <label>Official's Phone Number</label><span class="validation-star">*</span>
            <ob-input v-model.trim="StudentDetails.SignatoryAuthority.Phone" v-phone-number placeholder="Entetr Official's Phone Number" :class="{ 'ob-vuelidate_input-error': $v.StudentDetails.SignatoryAuthority.Phone.$error }"></ob-input>
            <span class="ob-vuelidate_error-msg" v-if="$v.StudentDetails.SignatoryAuthority.Phone.$dirty && !$v.StudentDetails.SignatoryAuthority.Phone.required"> Enter Phone Number</span>
            <span class="ob-vuelidate_error-msg" v-if="$v.StudentDetails.SignatoryAuthority.Phone.$dirty && !$v.StudentDetails.SignatoryAuthority.Phone.phoneNumber && $v.StudentDetails.SignatoryAuthority.Phone.required">Enter valid phone number</span>
            <span class="ob-vuelidate_error-msg" v-if="$v.StudentDetails.SignatoryAuthority.$dirty && !$v.StudentDetails.SignatoryAuthority.maxLength && $v.StudentDetails.SignatoryAuthority.phoneNumber">Enter valid phone number</span>
            <span class="ob-vuelidate_error-msg" v-if="$v.StudentDetails.SignatoryAuthority.$dirty && !$v.StudentDetails.SignatoryAuthority.minLength && $v.StudentDetails.SignatoryAuthority.phoneNumber ">Enter valid phone number</span>
          </div>
        </div>
      </div>

      <div class="row rowgap">
        <div class="col-md-4">
          <div class="form-group">
            <div class="radio-inline">
              <ob-radio name="trainingplan" val="1" v-model="trainingplanRadiobutton">Use existing Training plan</ob-radio>
            </div>
          </div>
        </div>
        <div class="col-md-4">
          <div class="form-group">
            <div class="radio-inline">
              <ob-radio name="trainingplan" val="2" v-model="trainingplanRadiobutton">Create new Training plan</ob-radio>
            </div>
          </div>
        </div>
        <div class="col-md-4 ">
          <div class="form-group">
            <div class="radio-inline">
              <ob-radio name="trainingplan" val="3" v-model="trainingplanRadiobutton">Request Employee to fill the plan</ob-radio>
            </div>
          </div>
        </div>
      </div>
    </template>

    <template v-if="showExistingTrainingPlan || showCreateTrainingPlan">
      <div class="row rowgap" v-if="showExistingTrainingPlan">
        <div class="col-md-4">
          <div class="form-group">
            <label>Select Training Plan</label><span class="validation-star">*</span> <i class="fa fa-info-circle" v-tooltip="'You can add training plan from settings.'"></i>
            <ob-select2 v-if="isCompleted" :options="trainingplanOptions" v-model="selectedTrainingPlan" :class="{ 'ob-vuelidate_input-error': $v.selectedTrainingPlan.$error }" :change="onChange(selectedTrainingPlan)"></ob-select2>
            <span class="ob-vuelidate_error-msg" v-if="$v.selectedTrainingPlan.$dirty && !$v.selectedTrainingPlan.requiredIf">Select training plan</span>
          </div>
        </div>
      </div>

      <p style=" color: #d80808;" v-if="showCreateTrainingPlan">
        Note : The training plan created here will be saved in the Settings automatically. This plan can be updated or removed anytime.
      </p>
      <div class="row rowgap">
        <div class="col-md-12">
          <div class="form-group">
            <label>Training Plan Title</label><span class="validation-star">*</span>
            <ob-input v-model.trim="TrainingPlan.Title"  placeholder="Enter Training Plan Title" :class="{ 'ob-vuelidate_input-error': $v.TrainingPlan.Title.$error }"></ob-input>
            <span class="ob-vuelidate_error-msg" v-if="$v.TrainingPlan.Title.$dirty && !$v.TrainingPlan.Title.required">Enter Training Plan Title</span>
          </div>
        </div>
      </div>
      <div class="row rowgap">
        <div class="col-md-12">
          <div class="form-group">
            <label>Student Role: Describe the student's role with the employer and how that role is directly related to enhancing the student's knowledge obtained through his or her qualifying STEM degree.</label>
            <ob-textarea v-model.trim="TrainingPlan.StudentRole"  placeholder="Enter student roles"></ob-textarea>
          </div>
        </div>
      </div>
      <div class="row rowgap">
        <div class="col-md-12">
          <div class="form-group">
            <label>Goals and Objectives: Describe how the assignment(s) with the employer will help the student achieve his or her specific objectives for workbased learning related to his or her STEM degree. The description must both specify the student's goals
              regarding specific knowledge, skills, or techniques as well as the means by which they will be achieved.</label>
            <ob-textarea v-model.trim="TrainingPlan.GoalsAndObjectives"  placeholder="Enter Goals and Objectives"></ob-textarea>
          </div>
        </div>
      </div>
      <div class="row rowgap">
        <div class="col-md-12">
          <div class="form-group">
            <label>Employer Oversight: Explain how the employer provides oversight and supervision of individuals filling positions such as that being filled by the named F-1 student. If the employer has a training program or related policy in place that controls
              such oversight and supervision, please describe.
            </label>
            <ob-textarea v-model.trim="TrainingPlan.EmployerOversight"   placeholder="Enter Employer Oversight"></ob-textarea>
          </div>
        </div>
      </div>
      <div class="row rowgap">
        <div class="col-md-12">
          <div class="form-group">
            <label>Measures and Assessments: Explain how the employer measures and confirms whether individuals filling positions such as that being filled by the named F-1 student are acquiring new knowledge and skills. If the employer has a training program
              or related policy in place that controls such measures and assessments, please describe.</label>
            <ob-textarea v-model.trim="TrainingPlan.MeasuresAndAssessments"  placeholder="Enter Measures and Assessments"></ob-textarea>
          </div>
        </div>
      </div>
      <div class="row rowgap">
        <div class="col-md-12">
          <div class="form-group">
            <label>Additional Remarks (optional): Provide additional information pertinent to the Plan.</label>
            <ob-textarea v-model.trim="TrainingPlan.Remarks"  placeholder="Enter Additional Remarks"></ob-textarea>
          </div>
        </div>
      </div>

    </template>
    <template v-if="showRequestTrainingPlan">
      <p style="color: #d80808;margin-bottom: 15px;">
        Note : Empty Training Plan (Section-5) will be shared with the student for completion.
      </p>
    </template>


    <div class="modal-footer">
      <ob-button type="secondary" @click="show = false">Cancel</ob-button>
      <ob-button type="primary" @click="onInitiateI983Click">Initiate</ob-button>
    </div>



  </div>


</template>
<script>
  import {
    required, minLength, maxLength, requiredIf, email, alpha, minValue
  }
  from 'vuelidate/lib/validators'
  import {
    req, withParams
  }
  from 'vuelidate/lib/validators/common'
  const DecimalNumber = withParams({
    type: 'DecimalNumber'
  }, value => {
    return !req(value) || /^\d+(\.\d{1,2})?$/.test(value);
  })
  const alphawithspace = (value) => {
    var alsp = /^[a-zA-Z\s]*$/i
    return alsp.test(value)
  }
  const phoneNumber = (value) => {
    var phone = /^[0-9 +()-]+$/i
    return phone.test(value)
  }
  const letterCount = withParams({
    type: 'letterCount'
  }, value => {
    if (value != null && value.length <= 150) {
      var strArr = value.split(" ");
      let error = true;
      strArr.forEach(function(word) {
        if (word.length > 100) {
          error = false
          return;
        }
      });
      return !req(value) || error
    } else {
      return true
    }

  })


  export default {
    props: ["openModal", "previousData"],
    data() {
      return {
        isCompleted: false,
        StudentDetails: {
          StudentName: '',
          Email: '',
          EmployerName: '',
          SignatoryAuthority: {
            SiteName: '',
            SiteAddress: '',
            NameOfOficial: '',
            Title: '',
            Email: '',
            Phone: ''
          },
        },
        TrainingPlan: {

          Id: '',
          Title: '',
          StudentRole: '',
          GoalsAndObjectives: '',
          EmployerOversight: '',
          MeasuresAndAssessments: '',
          Remarks: ''
        },
        I983Type: '0',
        show: false,
        MasterTrainingList: '',
        selectedTrainingPlan: '',
        trainingplanRadiobutton: '1',


        trainingplanOptions: {
          placeholder: {
            id: '-1',
            text: 'Please select'
          },
          data: [],
        }
      }
    },
    watch: {
      openModal(val) {
          this.show = val;
        },
        show(val) {
          this.$emit('update:openModal', val)
        },
        trainingplanRadiobutton(val) {
          this.selectedTrainingPlan = '';
          this._resetTrainingPlan();
        }
    },
    computed: {
      EmployeeId() {
          return this.$parent.$parent.EmployeeId;
        },
        StudentName() {
            return this.$parent.$parent.StudentName;
        },
        showExistingTrainingPlan() {
          this.$v.StudentDetails.$reset();
          this.$v.selectedTrainingPlan.$reset();
          if (this.trainingplanRadiobutton == '1') {
            return true
          } else return false
        },
        showCreateTrainingPlan() {
          this.$v.StudentDetails.$reset();
          this.$v.selectedTrainingPlan.$reset();
          if (this.trainingplanRadiobutton == '2') {
            return true
          } else return false
        },
        showRequestTrainingPlan() {
          this.$v.StudentDetails.$reset();
          this.$v.selectedTrainingPlan.$reset();
          if (this.trainingplanRadiobutton == '3') {
            return true
          } else return false
        }
    },
    created() {
      this.show = this.openModal;

      this.copyFromStore();
    },
    validations() {
      return {
        selectedTrainingPlan: {
          requiredIf: requiredIf(() => {
            return this.trainingplanRadiobutton == '1';
          })
        },
        StudentDetails: {
          "StudentName": {
            required,
            // alphawithspace,
            maxLength: maxLength(150),
              letterCount
          },
          "Email": {
            required,
            email
          },
          "EmployerName": {
            required,
            // alphawithspace,
            maxLength: maxLength(150),
              letterCount
          },
          "SignatoryAuthority": {
            "SiteName": {
              required,
              alphawithspace,
              maxLength: maxLength(150),
                letterCount
            },
            "SiteAddress": {
              required,
              maxLength: maxLength(150),
                letterCount
            },
            "NameOfOficial": {
              required,
              // alphawithspace,
              maxLength: maxLength(150),
                letterCount
            },
            "Title": {
              required,
              alphawithspace,
              maxLength: maxLength(150),
                letterCount
            },
            "Email": {
              required,
              email
            },
            "Phone": {
              required,
              phoneNumber,
              maxLength: maxLength(20),
              minLength: minLength(10),
            }
          },
        },
        TrainingPlan: {
          "Title": {
            required
          }
        }
      }
    },

    methods: {
      copyFromStore() {
        // Reset the Form Data
        this.resetData();

        // Pre-populate the data
        this.StudentDetails.StudentName = this.previousData.StudentName;
        this.StudentDetails.Email = this.previousData.StudentEmail;

        // Get Training List
        this.getTrainingList();
      },
      resetData() {
        this.isCompleted = false;
        this.StudentDetails = {
          StudentName: '',
          Email: '',
          EmployerName: '',
          SignatoryAuthority: {
            SiteName: '',
            SiteAddress: '',
            NameOfOficial: '',
            Title: '',
            Email: '',
            Phone: ''
          },
        };

        this._resetTrainingPlan();

        this.I983Type = '0';
        this.MasterTrainingList = '';
        this.selectedTrainingPlan = '';
        this.trainingplanRadiobutton = '1';

        // Reset Validations
        this.$v.StudentDetails.$reset();
        this.$v.selectedTrainingPlan.$reset();
        this.$v.TrainingPlan.$reset();
      },
      _resetTrainingPlan() {
        this.TrainingPlan = {
          Id: '',
          Title: '',
          StudentRole: '',
          GoalsAndObjectives: '',
          EmployerOversight: '',
          MeasuresAndAssessments: '',
          Remarks: ''
        };
      },
      onChange(selectedTrainingPlan) {
          if (selectedTrainingPlan) {
            for (var i = 0; i < this.MasterTrainingList.length; i++) {
              if (this.MasterTrainingList[i].Id == selectedTrainingPlan) {
                this.TrainingPlan.Title = this.MasterTrainingList[i].Title
                this.TrainingPlan.StudentRole = this.MasterTrainingList[i].StudentRole
                this.TrainingPlan.GoalsAndObjectives = this.MasterTrainingList[i].Objectives
                this.TrainingPlan.EmployerOversight = this.MasterTrainingList[i].EmployerOverSight
                this.TrainingPlan.MeasuresAndAssessments = this.MasterTrainingList[i].Assessments
                this.TrainingPlan.Remarks = this.MasterTrainingList[i].AdditionalRemarks
              }
            }
          }

        },
        isValid() {
          var valid = false

          if (this.trainingplanRadiobutton == '1' || this.trainingplanRadiobutton == '2') {
            this.$v.StudentDetails.$touch();
            this.$v.selectedTrainingPlan.$touch();
            this.$v.TrainingPlan.$touch();

            valid = !this.$v.StudentDetails.$invalid && !this.$v.selectedTrainingPlan.$invalid && !this.$v.TrainingPlan.$invalid;
          } else if (this.trainingplanRadiobutton == '3') {
            this.TrainingPlan.Title = ''
            this.$v.StudentDetails.$touch();
            valid = !this.$v.StudentDetails.$invalid
          }
          return valid
        },

        onInitiateI983Click() {
          var valid = this.isValid()
          if (valid) {
            this.$loading({
              'loadingText': 'Initiating Form I-983...'
            })

            var SignatoryAuthority = {
              
              Name: this.StudentDetails.SignatoryAuthority.NameOfOficial,
              Title: this.StudentDetails.SignatoryAuthority.Title == 'HRManager' ? 'HR Manager': this.StudentDetails.SignatoryAuthority.Title,
              Email: this.StudentDetails.SignatoryAuthority.Email,
              Phone: this.StudentDetails.SignatoryAuthority.Phone,
            };

            var employee = {
              Name: this.StudentDetails.StudentName,
              Email: this.StudentDetails.Email,
              EmployeeId: this.EmployeeId
            }
            var employer = {
              Name: this.StudentDetails.EmployerName,
              SignatoryAuthority: SignatoryAuthority

            }
            var training = {
              Title: this.TrainingPlan.Title == 'HRManager' ? 'HR Manager': this.TrainingPlan.Title,
              StudentRole: this.TrainingPlan.StudentRole,
              Objectives: this.TrainingPlan.GoalsAndObjectives,
              EmployerOverSight: this.TrainingPlan.EmployerOversight,
              Assessments: this.TrainingPlan.MeasuresAndAssessments,
              AdditionalRemarks: this.TrainingPlan.Remarks,
            }
            var assignedTraining = {
              SiteName: this.StudentDetails.SignatoryAuthority.SiteName,
              SiteAddress: this.StudentDetails.SignatoryAuthority.SiteAddress,
              Training: training
            }
            let I983Details = {
              Employee: employee,
              Employer: employer,
              AssignedTraining: assignedTraining,
              Type: this.I983Type
            }

            ajax.post(`/I983/Initiate`,I983Details, (res) => {

                  if(res.data.State == true){
                      if(this.trainingplanRadiobutton == '2') {
                        this.addTrainingToSettings(training);
                      } else {
                        this.showInitiateSuccess();
                      }
                  }else if(res.data.State == false){
                      this.$loading({}).close()
                      this.show = false
                      this.ESSEnableDisable(res)
                      this.$message({
                          type: 'error',
                          message: res.data.Message
                      });
                  }
              });
            }
        },

      addTrainingToSettings(training) {
          ajax.post(`/Training/Add`, training, (res) => {
            if (res.data.State == true) {
                this.showInitiateSuccess();
            }
            else
              this.ESSEnableDisable(res)
        });
      },

      showInitiateSuccess() {
        this.$message({
            type: 'success',
            message: 'FormI983 initiated Successfully'
        });
        this.$loading({}).close()
        this.show = false
        this.$emit('onShowEmailSuccessPopup', this.StudentDetails.StudentName);
      },
        getTrainingList() {
          this.isCompleted = false
          ajax.put(`Training/List?pageNo=0&pageSize=20`, {}, res => {
            this.MasterTrainingList = res.data.TrainingModelList
            this.trainingplanOptions.data = __.map(res.data.TrainingModelList, (t) => {
              return {
                'id': t.Id,
                'text': t.Title
              }
            })
            this.isCompleted = true
          })

        }
    }
  }
</script>
<style lang="scss" scoped>
  .title-content {
    color: #4a90e2;
    font-size: 14px;
  }

  .rowgap {
    margin-top: 10px;
  }

  .validation-star {
    color: #F31D1D;
  }

  .radio-inline {
    padding-left: 0px
  }

  label {
    color: #a4abb9
  }

  .preview-details {
    padding: 10px 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/ESSProfile/FormI983/InitiateFlow/InitiateI983Popup.vue